import { MessageData, SocketMessage, BreakoutMessage } from './types';

export function assertString(str: string | undefined | null): asserts str is string {
	if (typeof str !== 'string') {
		throw new Error('Must be a string');
	}
}

export function assertSocketMessage(message: MessageData | undefined): asserts message is SocketMessage {
	if (!message || !('type' in message && 'data' in message)) {
		throw new Error(`Illegal message type passed ${JSON.stringify(message)}`);
	}
}

export function assertBreakoutMessage(message: MessageData | undefined): asserts message is BreakoutMessage {
	if (!message || !('sessionUuid' in message)) {
		throw new Error(`Illegal message type passed ${JSON.stringify(message)}`);
	}
}